import type { TrainingLessonSpecific } from './trainingLessonUi';

export const highPriest1KeysEs: TrainingLessonSpecific = {
  intro:
    'El Sumo Sacerdote entiende llaves, autoridad y poder. Las llaves no te hacen más santo; te hacen más responsable. El sacerdocio sin caridad se vuelve ruido; con caridad, se vuelve poder real.',
  objectives: [
    'Entender el propósito del oficio de Sumo Sacerdote en el Sacerdocio de Melquisedec.',
    'Diferenciar llaves vs autoridad vs poder.',
    'Comprender cómo el sacerdocio se ejerce para bendecir, no para controlar.',
    'Aprender a apoyar y sostener a los líderes con lealtad y orden.',
    'Definir hábitos de dignidad y servicio que fortalecen la confianza del Señor.',
  ],
  briefHeading: 'Llaves y presidencia en breve',
  briefBody:
    'Las llaves ordenan la obra; el poder fluye según rectitud. Sostener a los líderes es parte del convenio del sacerdocio.',
  scriptures: [
    { ref: 'DyC 107:8–9', text: 'Melquisedec: llaves, poder y autoridad espiritual.' },
    { ref: 'DyC 121:41–42', text: 'Persuasión, longanimidad, benignidad, amor sincero.' },
    { ref: 'DyC 84:33–39', text: 'Juramento y convenio del sacerdocio.' },
    { ref: 'Hebreos 5:4', text: 'Nadie toma para sí esta honra, sino el que es llamado.' },
    { ref: 'DyC 20:60', text: 'El sacerdocio por el poder del Espíritu.' },
  ],
  didYouKnow: [
    'Las llaves no te hacen "más santo"; te hacen más responsable.',
    'El sacerdocio sin caridad se vuelve "ruido". Con caridad, se vuelve poder real.',
  ],
  practiceItems: [
    'Escribir en 1 frase la diferencia entre: llaves / autoridad / poder',
    'Identificar quién posee llaves en tu barrio y qué área preside (obispo, presidentes, etc.)',
    'Practicar "sostener": hacer 1 acto concreto de apoyo a un líder sin esperar reconocimiento',
    'Revisar tu conducta dominical: ¿qué hábito debo cambiar para ser más digno y reverente?',
    'Elegir 1 cosa para mejorar tu forma de hablar (menos crítica, más edificación)',
    'Hacer un "chequeo DyC 121": ¿estoy persuadiendo o empujando?',
  ],
  reflectionQuestions: [
    '¿Dónde confundo autoridad con control?',
    '¿Qué hábitos debo corregir para ser confiable espiritualmente?',
    '¿Cómo puedo sostener mejor a mis líderes esta semana?',
  ],
  actionText:
    'Sostener con hechos: elige 1 líder y apóyalo con una acción concreta (servicio, logística, ánimo, presencia).',
};
